export default {
    cn: {
        mt4ProfitLossReport: {
            timeText: '日期：',
            downloadName: 'MT5盈亏报表',
            loadText: '下载时间会比较长,请耐心等候...',
            sameDate: '日期不能是同一天',
            tableHead: [
                { key: 'DATE', value: '日期' },
                { key: 'LOGIN', value: '账号' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金货币' },
                { key: 'IB_ID', value: '代理账号' },
                { key: 'OFFICE_NAME', value: '所属办事处' },
                { key: 'OID', value: '办事处号码' },
                { key: 'ACC_NAME', value: '所属地区' },
                { key: 'RID', value: '地区编号' },
                { key: 'GROUP', value: '组别' },
                { key: 'TOTAL_CLOSE_PL', value: '总平仓盈亏' },
                { key: 'PREVIOUS_FLOATING', value: '之前浮动盈亏' },
                { key: 'PRESENT_FLOATING', value: '当前浮动盈亏' },
                { key: 'PREVIOUS_EQUITY', value: '之前净值' },
                { key: 'PRESENT_EQUITY', value: '当前净值' },
                { key: 'PROFITLOSS', value: '盈亏' },
            ]
        }
    },
    hk: {
        mt4ProfitLossReport: {
            timeText: '日期：',
            downloadName: 'MT5盈虧報表',
            loadText: '下載時間會比較長,請耐心等候...',
            sameDate: '日期不能是同一天',
            tableHead: [
                { key: 'DATE', value: '日期' },
                { key: 'LOGIN', value: '賬號' },
                { key: 'NAME', value: '姓名' },
                { key: 'CURRENCY', value: '入金貨幣' },
                { key: 'IB_ID', value: '代理賬號' },
                { key: 'OFFICE_NAME', value: '所屬辦事處' },
                { key: 'OID', value: '辦事處號碼' },
                { key: 'ACC_NAME', value: '所屬地區' },
                { key: 'RID', value: '地區編號' },
                { key: 'GROUP', value: '組別' },
                { key: 'TOTAL_CLOSE_PL', value: '總平倉盈虧' },
                { key: 'PREVIOUS_FLOATING', value: '之前浮動盈虧' },
                { key: 'PRESENT_FLOATING', value: '當前浮動盈虧' },
                { key: 'PREVIOUS_EQUITY', value: '之前淨值' },
                { key: 'PRESENT_EQUITY', value: '當前淨值' },
                { key: 'PROFITLOSS', value: '盈虧' },
            ]
        }
    },
    en: {
        mt4ProfitLossReport: {
            timeText: 'Date：',
            downloadName: 'MT5 Profit And Loss Report',
            loadText: 'The download time will be longer, please wait patiently...',
            sameDate: 'The dates cannot be the same',
            tableHead: [
                { key: 'DATE', value: 'Date' },
                { key: 'LOGIN', value: 'Login' },
                { key: 'NAME', value: 'Name' },
                { key: 'CURRENCY', value: 'Currency' },
                { key: 'IB_ID', value: 'IB Account' },
                { key: 'OFFICE_NAME', value: 'Office Name' },
                { key: 'OID', value: 'Office ID' },
                { key: 'ACC_NAME', value: 'Region Name' },
                { key: 'RID', value: 'Region ID' },
                { key: 'GROUP', value: 'Group' },
                { key: 'TOTAL_CLOSE_PL', value: 'Total Closed PL' },
                { key: 'PREVIOUS_FLOATING', value: 'Previous Floating PL' },
                { key: 'PRESENT_FLOATING', value: 'Present Floating PL' },
                { key: 'PREVIOUS_EQUITY', value: 'Previous Equity' },
                { key: 'PRESENT_EQUITY', value: 'Present Equity' },
                { key: 'PROFITLOSS', value: 'Profit/Loss' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/manager-report/mt4ProfitLossReport.js